import Siema from 'siema'
import carousel from '../carousel'

export default function carouselFactory (document, moduleHTML, appEventEmitter) {
  carousel(document, moduleHTML, appEventEmitter, Siema)
}
